import enviro from 'enviro';
import { lazy } from 'react';
import AlreadyAPartnerView from '../app-active-error/AlreadyAPartnerView';
import BlankScreenLoadingErrorView from '../app-active-error/BlankScreenLoadingErrorView';
import EmailVerificationStandardError from '../app-active-error/EmailVerificationStandardError';
import ExistingAccountLoginView from '../app-active-error/ExistingAccountLoginView';
import ManualLoginView from '../app-active-error/ManualLoginView';
import PartnerExistingAccountErrorView from '../app-active-error/PartnerExistingAccountErrorView';
import PendingEmailOAuthError from '../app-active-error/PendingEmailOAuthError';
import RateLimitedCreationError from '../app-active-error/RateLimitedCreationError';
import RateLimitedEmailVerification from '../app-active-error/RateLimitedEmailVerification';
import SessionExpiredErrorView from '../app-active-error/SessionExpiredErrorView';
import StandardCreationError from '../app-active-error/StandardCreationError';
import StandardError from '../app-active-error/StandardError';
import VerificationLinkExpiredView from '../app-active-error/VerificationLinkExpiredView';
import VerifyFirstCreationError from '../app-active-error/VerifyFirstCreationError';
import IntegratedAppAuthorizationErrorView from '../app-active-error/IntegratedAppAuthorizationErrorView';
import EmbeddedSignupContinueScreen from '../app/EmbeddedSignupContinueScreen';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import RecaptchaCreationErrorView from '../recaptcha/RecaptchaCreationErrorView';
import { RecaptchaMissingInformationErrorView } from '../recaptcha/RecaptchaMissingInformationErrorView';
import LandingPageView from '../step-landing-page/LandingPageView';
import { CompanyNameView } from './CompanyNameView';
import CompanySizeView from './CompanySizeView';
import CrmExperienceLevelView from './CrmExperienceLevelView';
import { Step } from 'signup-constants/Step';
import MissingBlogIdeasGeneratorScopesView from '../app-active-error/MissingBlogIdeasGeneratorScopesErrror';
let StepViews;
export const getStepView = stepKey => {
  if (typeof StepViews === 'undefined') {
    const LOG = Logger.getLogger('stepViews');
    const AfterFirstStepViewBundle = import( /* webpackChunkName: "afterFirstStepViews" */'./afterFirstStepViews');
    const AuthenticatedUserViewBundle = import('./authenticatedUserViews');
    const loadViewFromBundle = (bundle, view) => {
      return /*#__PURE__*/lazy(() => bundle.then(module => {
        return {
          default: module[view]
        };
      }).catch(error => {
        LOG.error('bundle error:', {
          extra: getSentryExtra(error)
        });
        return {
          default: null
        };
      }));
    };
    const BaseButtonStepView = loadViewFromBundle(AfterFirstStepViewBundle, 'BaseButtonsView');
    StepViews = new Map();

    // Step -> StepView Mapping
    StepViews.set(Step.CompanyName, CompanyNameView);
    StepViews.set(Step.CompanySize, CompanySizeView);
    StepViews.set(Step.CrmExperienceLevel, CrmExperienceLevelView);
    StepViews.set(Step.JobField, BaseButtonStepView);
    StepViews.set(Step.EmailVerificationNotFound, VerificationLinkExpiredView);
    StepViews.set(Step.InternalError, StandardError);
    StepViews.set(Step.LoginFailed, ManualLoginView);
    StepViews.set(Step.StandardCreationError, StandardCreationError);
    StepViews.set(Step.VerifyFirstCreationError, VerifyFirstCreationError);
    StepViews.set(Step.RateLimitedCreationError, RateLimitedCreationError);
    StepViews.set(Step.OAuthExistingLoginFailed, ExistingAccountLoginView);
    StepViews.set(Step.OAuthPendingEmailVerification, PendingEmailOAuthError);
    StepViews.set(Step.RateLimitedEmailVerification, RateLimitedEmailVerification);
    StepViews.set(Step.EmailVerificationFailed, EmailVerificationStandardError);
    StepViews.set(Step.SessionExpired, SessionExpiredErrorView);
    StepViews.set(Step.RecaptchaCreationError, RecaptchaCreationErrorView);
    StepViews.set(Step.RecaptchaMissingInformationError, RecaptchaMissingInformationErrorView);
    StepViews.set(Step.BlankScreenLoadingError, BlankScreenLoadingErrorView);
    StepViews.set(Step.PartnerExistingAccountError, PartnerExistingAccountErrorView);
    StepViews.set(Step.AlreadyAPartner, AlreadyAPartnerView);
    StepViews.set(Step.MissingBlogIdeasGeneratorScopesError, MissingBlogIdeasGeneratorScopesView);
    StepViews.set(Step.WordpressAuthorizationError, IntegratedAppAuthorizationErrorView);
    StepViews.set(Step.IntegratedAppAuthorizationError, IntegratedAppAuthorizationErrorView);
    StepViews.set(Step.EmbeddedSignupContinueScreen, EmbeddedSignupContinueScreen);
    StepViews.set(Step.Industry, loadViewFromBundle(AfterFirstStepViewBundle, 'IndustryView'));
    StepViews.set(Step.JobRole, loadViewFromBundle(AfterFirstStepViewBundle, 'JobRoleView'));
    StepViews.set(Step.ManagementLevel, loadViewFromBundle(AfterFirstStepViewBundle, 'ManagementLevelView'));
    StepViews.set(Step.Verification, loadViewFromBundle(AfterFirstStepViewBundle, 'VerificationView'));
    StepViews.set(Step.ResendEmail, loadViewFromBundle(AfterFirstStepViewBundle, 'ResendEmailView'));
    StepViews.set(Step.CodeVerification, loadViewFromBundle(AfterFirstStepViewBundle, 'CodeVerificationView'));
    StepViews.set(Step.Password, /*#__PURE__*/lazy(() => import( /* webpackChunkName: "step-password/PasswordView" */'../step-password/PasswordView')));
    StepViews.set(Step.MobileAppPrompt, /*#__PURE__*/lazy(() => import( /* webpackChunkName: "step-mobile-app-prompt/MobileAppPromptView" */'../step-mobile-app-prompt/MobileAppPromptView')));
    StepViews.set(Step.ExistingUser, loadViewFromBundle(AuthenticatedUserViewBundle, 'ExistingUserView'));
    StepViews.set(Step.ExistingAccounts, loadViewFromBundle(AuthenticatedUserViewBundle, 'ExistingAccountsView'));
    StepViews.set(Step.HublessNoAccount, loadViewFromBundle(AuthenticatedUserViewBundle, 'HublessView'));
    StepViews.set(Step.CompanyDomain, /*#__PURE__*/lazy(() => import( /* webpackChunkName: "step-company-domain/index */'../step-company-domain/index')));
    StepViews.set(Step.IntegrationsAccountCreated, /*#__PURE__*/lazy(() => import('./IntegrationsAccountCreatedView')));
    StepViews.set(Step.WordpressAuthorization, /*#__PURE__*/lazy(() => import('./IntegratedAppAuthorizationView')));
    StepViews.set(Step.IntegratedAppAuthorization, /*#__PURE__*/lazy(() => import('./IntegratedAppAuthorizationView')));
    StepViews.set(Step.WordpressConnectRedirect, /*#__PURE__*/lazy(() => import('./IntegratedAppConnectRedirectView')));
    StepViews.set(Step.IntegratedAppConnectRedirect, /*#__PURE__*/lazy(() => import('./IntegratedAppConnectRedirectView')));
    StepViews.set(Step.AcademyEmbeddedExistingUser, /*#__PURE__*/lazy(() => import('../step-existing-user/AcademyEmbeddedExistingUserView')));
    StepViews.set(Step.HubletSelection, /*#__PURE__*/lazy(() => import('../hublets/HubletSelectionView')));
    StepViews.set(Step.Country, /*#__PURE__*/lazy(() => import('../countrySelect/CountrySelectView')));
    StepViews.set(Step.PhoneNumber, /*#__PURE__*/lazy(() => import('../step-phone-number/PhoneNumberView')));
    StepViews.set(Step.OptionalPhoneNumber, /*#__PURE__*/lazy(() => import('../step-phone-number/PhoneNumberOptionalView')));
    StepViews.set(Step.Name, /*#__PURE__*/lazy(() => import('./NameView')));
    StepViews.set(Step.LandingPage, LandingPageView);
    StepViews.set(Step.InstallSalesExtension, /*#__PURE__*/lazy(() => import('../views-components/InstallSalesExtensionView')));
    StepViews.set(Step.CmsSignupIntent, /*#__PURE__*/lazy(() => import('./CmsSignupIntentView')));
    StepViews.set(Step.CmsBusinessMaturity, /*#__PURE__*/lazy(() => import('./CmsBusinessMaturityView')));
    StepViews.set(Step.Review, /*#__PURE__*/lazy(() => import('./ReviewView')));
    StepViews.set(Step.LoadingPage, /*#__PURE__*/lazy(() => import('./LoadingView')));

    // Local development information
    if (enviro.isQa() && !enviro.deployed()) {
      const allSteps = Object.values(Step);
      const notIncludedInConfig = allSteps.filter(x => !StepViews.has(x));
      /* eslint-disable-next-line  no-console */
      console.group('StepViews Debug Information');
      /* eslint-disable-next-line  no-console */
      console.info('Step without a view component registered', notIncludedInConfig);
      /* eslint-disable-next-line  no-console */
      console.groupEnd();
    }
  }
  const view = StepViews.get(stepKey);
  if (!view) {
    throw new Error(`No step view registered for step ${stepKey}. Check StepViews mapping.`);
  }
  return view;
};